const mockUser: any = {};

export default mockUser;
